import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
import { classNames } from "../../../utils";
export const CourtyardLogo = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = classNames(fillVariants({
      fill: "current"
    }), className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M19.423 6.99796C19.8676 6.05989 20.6298 5.31108 21.5735 4.88533V4.88247C23.3274 7.2728 24.1365 10.231 23.8444 13.1855C23.5522 16.14 22.1797 18.8807 19.9919 20.8782C17.8042 22.8756 14.9568 23.9878 11.9998 23.9999C9.04289 24.0118 6.18654 22.9228 3.9828 20.9434C1.77906 18.9637 0.384417 16.2342 0.0684543 13.2822C-0.247509 10.3303 0.537635 7.36552 2.27212 4.961C4.00662 2.55647 6.56731 0.882922 9.45922 0.263822C12.3511 -0.355279 15.3691 0.124027 17.9295 1.60909C18.3617 1.85856 18.7766 2.13724 19.1712 2.44321C17.9126 3.2702 16.925 4.45176 16.3323 5.83982C14.7577 4.65809 12.7895 4.13235 10.8382 4.37226L11.7047 7.62412C12.6724 7.61024 13.6171 7.92082 14.3893 8.50672C15.1614 9.09262 15.7168 9.92039 15.9676 10.8589C16.2184 11.7974 16.1503 12.7932 15.774 13.6885C15.3976 14.5837 14.7346 15.3274 13.89 15.8018L14.7579 19.0522C16.4515 18.3275 17.8279 17.0137 18.6342 15.3517C19.4404 13.69 19.6226 11.7918 19.147 10.006C18.8806 9.00224 18.9785 7.93604 19.423 6.99796ZM7.74427 10.2943C8.12062 9.39929 8.78347 8.65589 9.62789 8.18167L8.76007 4.93406C7.06723 5.65895 5.69177 6.97287 4.88643 8.63437C4.08108 10.2959 3.89994 12.1934 4.37629 13.9783C4.85265 15.7632 5.9545 17.3155 7.47938 18.3501C9.00427 19.3846 10.8498 19.8319 12.6768 19.6098L11.8104 16.3593C10.8428 16.3726 9.89864 16.0615 9.12704 15.4754C8.35537 14.8892 7.80044 14.0615 7.55002 13.1232C7.29959 12.1847 7.36795 11.1893 7.74427 10.2943Z" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest || $[8] !== size || $[9] !== t2) {
    t4 = <svg aria-label="Courtyard" className={t2} fill="currentColor" height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = rest;
    $[8] = size;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};